import React from 'react';
import ReactPhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export const PhoneInput = props => {
  const { placeholder, input, disabled } = props;
  return <ReactPhoneInput {...input} country="AU" countries={['AU', 'NZ']} placeholder={placeholder} disabled={disabled} international={false} />;
};
